class CookieBotHandler {
	constructor() {

      if(document.querySelector('#oneTrustScript')) {
        document.querySelectorAll('#oneTrustScript').forEach(elem => elem.remove());
      }

      if(document.querySelector('#onetrust-pc-sdk')) {
        document.querySelectorAll('#onetrust-pc-sdk').forEach(elem => elem.remove());
      }

      if(!document.querySelector('#oneTrustScript')) {

        this.url = location.href;
        this.oneTrustId = "4695c7be-5017-4c3a-aabb-90d6c39ae9d9"
        this.language = document.getElementsByTagName("html")[0].getAttribute("lang");
        this.linkLogo = "https://jobboerse.strabag.at/img/strabag-logo-300px.png"; //Link zum Logo

        this.openCookiesButton = document.getElementById("ot-sdk-btn");

        let script2 = document.createElement('script');
        script2.setAttribute("data-document-language", true);
        script2.setAttribute("charset", "UTF-8");
        script2.setAttribute("data-domain-script", this.oneTrustId);
        script2.id = 'oneTrustScript';
        script2.setAttribute("data-language", this.language);
        script2.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

        if(this.language == "en"){
          this.linkDSE = "/dataprotectionstatement";
          this.titleDSE = "Data Protection Statement";
          this.linkImprint = "/imprint";
          this.titleImprint = "Imprint";

        } else {
            this.linkDSE = "/datenschutzerklaerung";
            this.titleDSE = "Datenschutzerklärung";
            this.linkImprint = "/impressum";
            this.titleImprint = "Impressum";
        }

        setTimeout(() => {

          document.head.prepend(script2);

          this.OptanonWrapper();

          if(this.openCookiesButton) {
            this.openCookies();
          }

        }, 200);
      }

	}

  openCookies() {
    this.openCookiesButton.addEventListener('click', () => {
      if(document.getElementById('onetrust-consent-sdk')){
        document.getElementById('onetrust-consent-sdk').style.display = 'block';
      }
      if(document.getElementById('onetrust-banner-sdk')){
        document.getElementById('onetrust-banner-sdk').style.display = 'none';
      }
    });
  }

  OptanonWrapper() {
    if(document.getElementById("onetrust-policy-text")){
      if (!document.getElementById("divDSEImprint")) {
        document.getElementById("onetrust-policy-text").innerHTML +=
          '<div id="divDSEImprint" style="width:100%; text-align:left;font-size:14px;padding-top:10px"><a href="' + this.linkDSE  + '" style="margin-left:0px; outline:0px !important; font-weight:normal;">' + this.titleDSE  + '</a> | <a href="' + this.linkImprint  + '" style="margin-left:1px; outline:0px !important; font-weight:normal;">' + this.titleImprint  + '</a></div>';
      }
    }

    if(document.getElementById("ot-pc-desc")){
      if (!document.getElementById("divDSE")) {
        document.getElementById("ot-pc-desc").innerHTML +=
          '<style>#onetrust-pc-sdk a{color:#d72622;}#onetrust-pc-sdk a:hover{color:#d72622;}</style><div id="divDSE" style="width:100%; text-align:left;font-size:14px;padding-top:10px"><a href="' + this.linkDSE  + '" style="margin-left:0px; outline:0px !important; font-weight:normal;">' + this.titleDSE  + '</a></div>';
      }
    }

    if(document.getElementsByClassName('banner_logo')[0]){
      document.getElementsByClassName('banner_logo')[0].innerHTML =  '<img src="' + this.linkLogo + '" style="height:60px;">';
    }

    if(document.getElementsByClassName('banner_logo')[0]){
      document.getElementsByClassName('banner_logo')[0].style.display =  'block';
    }

    if(document.getElementsByClassName('banner_logo')[0]){
      document.getElementsByClassName('banner_logo')[0].style.margin =  '0px 0px 10px 30px';
    }

    if(document.getElementsByClassName('privacy-notice-link')[0]){
        document.getElementsByClassName('privacy-notice-link')[0].style.display =  'none';
    }
  }
}

export default CookieBotHandler;
